export const translations = {
  es: {
    // Navigation
    nav: {
      dashboard: 'Panel',
      tandas: 'Tandas',
      create: 'Crear Tanda',
      plans: 'Planes',
      profile: 'Perfil',
      logout: 'Cerrar Sesión',
    },

    // Login
    login: {
      appName: 'TandaExpress',
      subtitle: 'Gestiona tus tandas de ahorro en linea',
      welcome: 'Bienvenido',
      signIn: 'Iniciar Sesion',
      usernameOrEmail: 'Usuario o Correo',
      password: 'Contrasena',
      signingIn: 'Iniciando sesion...',
      noAccount: 'No tienes cuenta?',
      signUp: 'Registrate',
      demoCredentials: 'Credenciales de Demo',
      username: 'Usuario',
      allRights: 'Todos los derechos reservados.',
    },

    // Register
    register: {
      title: 'Crear Cuenta',
      subtitle: 'Unete a nuestra comunidad de ahorro',
      fillDetails: 'Completa tus datos para comenzar',
      fullName: 'Nombre Completo',
      email: 'Correo Electronico',
      username: 'Nombre de Usuario',
      phone: 'Telefono (Opcional)',
      password: 'Contrasena',
      confirmPassword: 'Confirmar Contrasena',
      address: 'Direccion (Opcional)',
      passwordReq: 'Requisitos de contrasena:',
      passwordMin: 'Al menos 8 caracteres',
      passwordUpper: 'Al menos una mayuscula',
      passwordLower: 'Al menos una minuscula',
      passwordNumber: 'Al menos un numero',
      creating: 'Creando cuenta...',
      createAccount: 'Crear Cuenta',
      hasAccount: 'Ya tienes cuenta?',
      signIn: 'Iniciar sesion',
      terms: 'Al crear una cuenta, aceptas nuestros',
      termsOfService: 'Terminos de Servicio',
      and: 'y',
      privacyPolicy: 'Politica de Privacidad',
    },

    // Dashboard
    dashboard: {
      welcomeBack: 'Bienvenido,',
      subtitle: 'Esto es lo que pasa con tus tandas hoy.',
      totalTandas: 'Total Tandas',
      activeTandas: 'Tandas Activas',
      totalContributions: 'Contribuciones Totales',
      upcomingPayments: 'Proximos Pagos',
      activeTandasTitle: 'Tandas Activas',
      createNew: 'Crear Nueva',
      noActiveTandas: 'No tienes tandas activas. Crea o unete a una para comenzar!',
      members: 'Miembros',
      contribution: 'Aportacion:',
      total: 'Total:',
      started: 'Inicio',
      view: 'Ver',
      quickActions: 'Acciones Rapidas',
      createTanda: 'Crear Tanda',
      browseTandas: 'Explorar Tandas',
      makePayment: 'Hacer Pago',
      viewHistory: 'Ver Historial',
      upcomingPaymentsTitle: 'Proximos Pagos',
      noUpcomingPayments: 'Sin pagos proximos',
      viewAllPayments: 'Ver Todos los Pagos',
      recentActivity: 'Actividad Reciente',
      paymentReceived: 'Pago Recibido',
      newMember: 'Nuevo Miembro',
      paymentReminder: 'Recordatorio de Pago',
      tandaCompleted: 'Tanda Completada',
      viewAllActivity: 'Ver Toda la Actividad',
      tips: 'Consejos para Tandas',
      tip1: 'Siempre paga a tiempo para mantener la confianza',
      tip2: 'Comunicate regularmente con tu grupo',
      tip3: 'Lleva registro de todas las transacciones',
      tip4: 'Empieza con montos pequenos para grupos nuevos',
      welcomeTitle: 'Bienvenido a TandaExpress!',
      welcomeText: 'Aun no has creado ni te has unido a ninguna tanda. Las tandas son grupos de ahorro rotativo donde los miembros contribuyen regularmente y por turnos reciben el monto total.',
      createFirst: 'Crea Tu Primera Tanda',
      browse: 'Explorar Tandas',
    },

    // Tandas page
    tandas: {
      title: 'Tandas',
      subtitle: 'Explora y unete a grupos de ahorro rotativo',
      searchPlaceholder: 'Buscar tandas por nombre, descripcion u organizador...',
      filter: 'Filtrar',
      sort: 'Ordenar',
      createTanda: 'Crear Tanda',
      status: 'Estado',
      allStatus: 'Todos',
      forming: 'Formandose',
      active: 'Activa',
      completed: 'Completada',
      cancelled: 'Cancelada',
      frequency: 'Frecuencia',
      allFrequencies: 'Todas',
      weekly: 'Semanal',
      biweekly: 'Quincenal',
      monthly: 'Mensual',
      newest: 'Mas Recientes',
      oldest: 'Mas Antiguos',
      highestAmount: 'Mayor Monto',
      lowestAmount: 'Menor Monto',
      mostMembers: 'Mas Miembros',
      fewestMembers: 'Menos Miembros',
      allTandas: 'Todas las Tandas',
      myTandas: 'Mis Tandas',
      showing: 'Mostrando',
      of: 'de',
      noTandas: 'No se encontraron tandas',
      adjustFilters: 'Intenta ajustar tu busqueda o filtros',
      noJoined: 'Aun no te has unido a ninguna tanda',
      noAvailable: 'No hay tandas disponibles por el momento',
      createFirst: 'Crear Primera Tanda',
      viewDetails: 'Ver Detalles',
      join: 'Unirse',
      member: 'Miembro',
      filled: 'llena',
      totalPot: 'Pozo total',
      whatIsTanda: 'Que es una Tanda?',
      tandaExplanation: 'Una tanda (tambien conocida como ROSCA) es un grupo de personas que acuerdan reunirse por un periodo definido para ahorrar y prestarse mutuamente. Cada miembro contribuye una cantidad fija en intervalos regulares, y cada periodo un miembro recibe la suma total recolectada.',
      benefits: 'Beneficios:',
      benefit1: 'Disciplina de ahorro',
      benefit2: 'Acceso a sumas grandes sin intereses',
      benefit3: 'Construye confianza y comunidad',
      benefit4: 'Flexible y transparente',
    },

    // Create Tanda
    createTanda: {
      title: 'Crear Nueva Tanda',
      subtitle: 'Configura un nuevo grupo de ahorro rotativo',
      backToTandas: 'Volver a Tandas',
      step1: 'Info Basica',
      step2: 'Detalles Financieros',
      step3: 'Calendario',
      step4: 'Revisar',
      tandaName: 'Nombre de la Tanda',
      description: 'Descripcion (Opcional)',
      describeHelp: 'Describe el proposito de esta tanda',
      numberOfMembers: 'Numero de Miembros',
      contributionAmount: 'Monto de Aportacion',
      totalAmount: 'Monto Total',
      calculatedAuto: 'Calculado automaticamente',
      eachMemberContributes: 'Cada miembro aportara',
      perPeriod: 'por periodo.',
      totalPotOf: 'El pozo total de',
      distributedAmong: 'sera distribuido entre',
      membersWord: 'miembros.',
      paymentFrequency: 'Frecuencia de Pago',
      startDate: 'Fecha de Inicio',
      tandaWillRun: 'Esta tanda durara',
      withPeriods: 'con',
      paymentPeriods: 'periodos de pago.',
      membersWillPay: 'Los miembros haran pagos cada',
      weeks: 'semanas',
      review: 'Revisa Tu Tanda',
      membersLabel: 'Miembros',
      contributionLabel: 'Aportacion',
      totalPot: 'Pozo Total',
      frequencyLabel: 'Frecuencia',
      startDateLabel: 'Fecha de Inicio',
      durationLabel: 'Duracion',
      importantNote: 'Importante:',
      importantText: 'Una vez que crees esta tanda, seras el organizador. No puedes cambiar los detalles financieros despues de crearla. Asegurate de que toda la informacion sea correcta.',
      back: 'Atras',
      next: 'Siguiente',
      creating: 'Creando...',
      create: 'Crear Tanda',
      commission: 'Comision por ronda',
      recipientReceives: 'El receptor recibira',
      tipsTitle: 'Consejos para Crear una Tanda Exitosa',
      tip1: 'Elige miembros de confianza: Empieza con personas que conoces',
      tip2: 'Montos realistas: Asegurate de que las aportaciones sean accesibles para todos',
      tip3: 'Comunicacion clara: Establece reglas y expectativas desde el inicio',
      tip4: 'Empieza pequeno: Considera una tanda corta con pocos miembros para tu primer grupo',
      tip5: 'Se transparente: Lleva registros claros y comunica regularmente',
    },

    // Tanda Detail
    tandaDetail: {
      backToTandas: 'Volver a Tandas',
      organizedBy: 'Organizada por',
      members: 'Miembros',
      contribution: 'Aportacion',
      totalPot: 'Pozo Total',
      frequency: 'Frecuencia',
      joinTanda: 'Unirse a Tanda',
      makePayment: 'Hacer Pago',
      startTanda: 'Iniciar Tanda',
      startMenu: 'Iniciar Tanda',
      editTanda: 'Editar Tanda',
      deleteTanda: 'Eliminar Tanda',
      leaveTanda: 'Salir de Tanda',
      description: 'Descripcion',
      noDescription: 'Sin descripcion.',
      startDate: 'Fecha de Inicio',
      duration: 'Duracion',
      organizer: 'Organizador',
      created: 'Creada',
      months: 'meses',
      membersTab: 'Miembros',
      roundsTab: 'Rondas',
      paymentsTab: 'Pagos',
      position: 'Posicion',
      joined: 'Se unio',
      notStarted: 'La tanda aun no ha iniciado. Las rondas apareceran cuando inicie.',
      round: 'Ronda',
      due: 'Vence:',
      completed: 'Completada',
      pending: 'Pendiente',
      paymentHistory: 'Historial de Pagos',
      noPayments: 'Aun no hay pagos registrados.',
      paidOn: 'Pagado el',
      notPaidYet: 'Aun no pagado',
      tandaStatus: 'Estado de la Tanda',
      progress: 'Progreso',
      membersJoined: 'miembros unidos',
      inProgress: 'Tanda en progreso',
      tandaCompleted: 'Tanda completada',
      tandaCancelled: 'Tanda cancelada',
      nextSteps: 'Siguientes Pasos',
      inviteMembers: 'Invitar miembros',
      spotsRemaining: 'lugares restantes',
      startTandaStep: 'Iniciar tanda',
      allSpotsFilled: 'Todos los lugares llenos',
      makePaymentsStep: 'Hacer pagos',
      dueAccordingSchedule: 'Segun el calendario',
      trackRounds: 'Seguir rondas',
      monitorFunds: 'Monitorea quien recibe los fondos',
      tandaRules: 'Reglas de la Tanda',
      ruleContribute: 'Cada miembro aporta',
      ruleReceive: 'Un miembro recibe',
      eachRound: 'cada ronda',
      ruleOrder: 'El orden se determina al azar al iniciar',
      ruleOnTime: 'Los pagos deben hacerse a tiempo',
      ruleLate: 'Los pagos tardios pueden tener penalizacion',
      ruleOrganizer: 'El organizador administra la tanda y distribuciones',
      ruleCommission: 'Comision por ronda:',
      shareTitle: 'Compartir esta Tanda',
      shareText: 'Invita a amigos y familiares de confianza a esta tanda.',
      copyLink: 'Copiar Enlace',
      linkCopied: 'Enlace copiado!',
      startDialogTitle: 'Iniciar Tanda',
      startDialogWarning: 'Una vez que inicies la tanda, no podras:',
      startDialogWarning1: 'Cambiar posiciones de los miembros',
      startDialogWarning2: 'Agregar o quitar miembros',
      startDialogWarning3: 'Modificar montos de aportacion',
      startDialogText: 'La tanda comenzara el',
      startDialogText2: 'Las posiciones se asignaran al azar (excepto tu como organizador seras el primero).',
      startDialogConfirm: 'Estas seguro de que quieres iniciar esta tanda?',
      cancel: 'Cancelar',
      deleteDialogTitle: 'Eliminar Tanda',
      deleteDialogWarning: 'Esta accion no se puede deshacer. Todos los datos de la tanda se eliminaran permanentemente.',
      deleteDialogText: 'Esto eliminara',
      deleteDialogText2: 'y todos los datos asociados incluyendo registros de miembros e historial de pagos.',
      deleteDialogConfirm: 'Estas seguro de que quieres eliminar esta tanda?',
    },

    // Profile
    profile: {
      title: 'Mi Perfil',
      subtitle: 'Administra tu cuenta y ve tu actividad',
      editProfile: 'Editar Perfil',
      changePassword: 'Cambiar Contrasena',
      memberSince: 'Miembro desde',
      accountStats: 'Estadisticas',
      tandas: 'Tandas',
      paymentsMade: 'Pagos Hechos',
      pendingPayments: 'Pendientes',
      completedTandas: 'Completadas',
      profileTab: 'Perfil',
      myTandasTab: 'Mis Tandas',
      paymentHistoryTab: 'Historial de Pagos',
      activityTab: 'Actividad',
      profileInfo: 'Tu informacion de perfil se usa para identificarte en los grupos de tanda y para comunicacion.',
      fullName: 'Nombre Completo',
      username: 'Nombre de Usuario',
      email: 'Correo',
      phone: 'Telefono',
      address: 'Direccion',
      notProvided: 'No proporcionado',
      saveChanges: 'Guardar Cambios',
      cancelEdit: 'Cancelar',
      myTandas: 'Mis Tandas',
      noTandas: 'Aun no has creado ni te has unido a ninguna tanda.',
      paymentHistory: 'Historial de Pagos',
      noPayments: 'Sin historial de pagos disponible.',
      amount: 'Monto',
      recentActivity: 'Actividad Reciente',
      currentPassword: 'Contrasena Actual',
      newPassword: 'Nueva Contrasena',
      confirmNewPassword: 'Confirmar Nueva Contrasena',
      changing: 'Cambiando...',
      change: 'Cambiar Contrasena',
      plan: 'Plan',
    },

    // Plans page
    plans: {
      title: 'Planes y Precios',
      subtitle: 'Elige el plan que mejor se adapte a tus necesidades',
      currentPlan: 'Plan Actual',
      popular: 'Popular',
      perMonth: '/mes',
      free: 'Gratis',
      selectPlan: 'Seleccionar Plan',
      currentLabel: 'Tu Plan Actual',
      features: 'Caracteristicas',
      commission: 'comision por ronda',
      activeTandas: 'tandas activas',
      membersPerTanda: 'miembros por tanda',
      unlimited: 'Ilimitadas',
      faq: 'Preguntas Frecuentes',
      faq1q: 'Como se cobra la comision?',
      faq1a: 'La comision se descuenta automaticamente del pozo al completar cada ronda. Es transparente y sin sorpresas.',
      faq2q: 'Puedo cambiar de plan en cualquier momento?',
      faq2a: 'Si, puedes subir o bajar de plan cuando quieras. Los cambios aplican inmediatamente.',
      faq3q: 'Que pasa si cancelo mi plan Premium?',
      faq3a: 'Vuelves al plan Gratis. Tus tandas activas siguen funcionando, pero aplicara la comision del plan Gratis en futuras rondas.',
    },

    // Common
    common: {
      loading: 'Cargando...',
      error: 'Error',
      success: 'Exito',
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      back: 'Atras',
      next: 'Siguiente',
      mxn: 'MXN',
      weekly: 'Semanal',
      biweekly: 'Quincenal',
      monthly: 'Mensual',
    },
  },

  en: {
    // Navigation
    nav: {
      dashboard: 'Dashboard',
      tandas: 'Tandas',
      create: 'Create Tanda',
      plans: 'Plans',
      profile: 'Profile',
      logout: 'Logout',
    },

    // Login
    login: {
      appName: 'TandaExpress',
      subtitle: 'Manage your rotating savings groups online',
      welcome: 'Welcome Back',
      signIn: 'Sign In',
      usernameOrEmail: 'Username or Email',
      password: 'Password',
      signingIn: 'Signing in...',
      noAccount: "Don't have an account?",
      signUp: 'Sign up',
      demoCredentials: 'Demo Credentials',
      username: 'Username',
      allRights: 'All rights reserved.',
    },

    // Register
    register: {
      title: 'Create Account',
      subtitle: 'Join our rotating savings community',
      fillDetails: 'Fill in your details to get started',
      fullName: 'Full Name',
      email: 'Email Address',
      username: 'Username',
      phone: 'Phone Number (Optional)',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      address: 'Address (Optional)',
      passwordReq: 'Password must contain:',
      passwordMin: 'At least 8 characters',
      passwordUpper: 'At least one uppercase letter',
      passwordLower: 'At least one lowercase letter',
      passwordNumber: 'At least one number',
      creating: 'Creating Account...',
      createAccount: 'Create Account',
      hasAccount: 'Already have an account?',
      signIn: 'Sign in',
      terms: 'By creating an account, you agree to our',
      termsOfService: 'Terms of Service',
      and: 'and',
      privacyPolicy: 'Privacy Policy',
    },

    // Dashboard
    dashboard: {
      welcomeBack: 'Welcome back,',
      subtitle: "Here's what's happening with your tandas today.",
      totalTandas: 'Total Tandas',
      activeTandas: 'Active Tandas',
      totalContributions: 'Total Contributions',
      upcomingPayments: 'Upcoming Payments',
      activeTandasTitle: 'Active Tandas',
      createNew: 'Create New',
      noActiveTandas: "You don't have any active tandas. Create or join one to get started!",
      members: 'Members',
      contribution: 'Contribution:',
      total: 'Total:',
      started: 'Started',
      view: 'View',
      quickActions: 'Quick Actions',
      createTanda: 'Create Tanda',
      browseTandas: 'Browse Tandas',
      makePayment: 'Make Payment',
      viewHistory: 'View History',
      upcomingPaymentsTitle: 'Upcoming Payments',
      noUpcomingPayments: 'No upcoming payments',
      viewAllPayments: 'View All Payments',
      recentActivity: 'Recent Activity',
      paymentReceived: 'Payment Received',
      newMember: 'New Member Joined',
      paymentReminder: 'Payment Reminder',
      tandaCompleted: 'Tanda Completed',
      viewAllActivity: 'View All Activity',
      tips: 'Tanda Tips',
      tip1: 'Always make payments on time to maintain trust',
      tip2: 'Communicate regularly with your tanda group',
      tip3: 'Keep records of all transactions',
      tip4: 'Start with small amounts for new groups',
      welcomeTitle: 'Welcome to TandaExpress!',
      welcomeText: "You haven't joined or created any tandas yet. Tandas are rotating savings groups where members contribute regularly and take turns receiving the total amount.",
      createFirst: 'Create Your First Tanda',
      browse: 'Browse Tandas',
    },

    // Tandas page
    tandas: {
      title: 'Tandas',
      subtitle: 'Browse and join rotating savings groups',
      searchPlaceholder: 'Search tandas by name, description, or organizer...',
      filter: 'Filter',
      sort: 'Sort',
      createTanda: 'Create Tanda',
      status: 'Status',
      allStatus: 'All Status',
      forming: 'Forming',
      active: 'Active',
      completed: 'Completed',
      cancelled: 'Cancelled',
      frequency: 'Frequency',
      allFrequencies: 'All Frequencies',
      weekly: 'Weekly',
      biweekly: 'Bi-weekly',
      monthly: 'Monthly',
      newest: 'Newest First',
      oldest: 'Oldest First',
      highestAmount: 'Highest Amount',
      lowestAmount: 'Lowest Amount',
      mostMembers: 'Most Members',
      fewestMembers: 'Fewest Members',
      allTandas: 'All Tandas',
      myTandas: 'My Tandas',
      showing: 'Showing',
      of: 'of',
      noTandas: 'No tandas found',
      adjustFilters: 'Try adjusting your search or filters',
      noJoined: "You haven't joined any tandas yet",
      noAvailable: 'No tandas available at the moment',
      createFirst: 'Create First Tanda',
      viewDetails: 'View Details',
      join: 'Join',
      member: 'Member',
      filled: 'filled',
      totalPot: 'Total pot',
      whatIsTanda: 'What is a Tanda?',
      tandaExplanation: 'A tanda (also known as a ROSCA - Rotating Savings and Credit Association) is a group of people who agree to meet for a defined period in order to save and borrow together. Each member contributes a fixed amount at regular intervals, and each period one member receives the total collected sum.',
      benefits: 'Benefits:',
      benefit1: 'Forced savings discipline',
      benefit2: 'Access to lump sums without interest',
      benefit3: 'Builds trust and community',
      benefit4: 'Flexible and transparent',
    },

    // Create Tanda
    createTanda: {
      title: 'Create New Tanda',
      subtitle: 'Set up a new rotating savings group',
      backToTandas: 'Back to Tandas',
      step1: 'Basic Info',
      step2: 'Financial Details',
      step3: 'Schedule',
      step4: 'Review',
      tandaName: 'Tanda Name',
      description: 'Description (Optional)',
      describeHelp: 'Describe the purpose of this tanda',
      numberOfMembers: 'Number of Members',
      contributionAmount: 'Contribution Amount',
      totalAmount: 'Total Amount',
      calculatedAuto: 'Calculated automatically',
      eachMemberContributes: 'Each member will contribute',
      perPeriod: 'per period.',
      totalPotOf: 'The total pot of',
      distributedAmong: 'will be distributed among',
      membersWord: 'members.',
      paymentFrequency: 'Payment Frequency',
      startDate: 'Start Date',
      tandaWillRun: 'This tanda will run for',
      withPeriods: 'with',
      paymentPeriods: 'payment periods.',
      membersWillPay: 'Members will make payments every',
      weeks: 'weeks',
      review: 'Review Your Tanda',
      membersLabel: 'Members',
      contributionLabel: 'Contribution',
      totalPot: 'Total Pot',
      frequencyLabel: 'Frequency',
      startDateLabel: 'Start Date',
      durationLabel: 'Duration',
      importantNote: 'Important:',
      importantText: 'Once you create this tanda, you will become the organizer. You cannot change the financial details after creation. Make sure all information is correct.',
      back: 'Back',
      next: 'Next',
      creating: 'Creating...',
      create: 'Create Tanda',
      commission: 'Commission per round',
      recipientReceives: 'Recipient receives',
      tipsTitle: 'Tips for Creating a Successful Tanda',
      tip1: 'Choose trusted members: Start with people you know and trust',
      tip2: 'Set realistic amounts: Make sure contributions are affordable for all',
      tip3: 'Clear communication: Establish rules and expectations upfront',
      tip4: 'Start small: Consider a shorter tanda with fewer members for your first group',
      tip5: 'Be transparent: Keep clear records and communicate regularly',
    },

    // Tanda Detail
    tandaDetail: {
      backToTandas: 'Back to Tandas',
      organizedBy: 'Organized by',
      members: 'Members',
      contribution: 'Contribution',
      totalPot: 'Total Pot',
      frequency: 'Frequency',
      joinTanda: 'Join Tanda',
      makePayment: 'Make Payment',
      startTanda: 'Start Tanda',
      startMenu: 'Start Tanda',
      editTanda: 'Edit Tanda',
      deleteTanda: 'Delete Tanda',
      leaveTanda: 'Leave Tanda',
      description: 'Description',
      noDescription: 'No description provided.',
      startDate: 'Start Date',
      duration: 'Duration',
      organizer: 'Organizer',
      created: 'Created',
      months: 'months',
      membersTab: 'Members',
      roundsTab: 'Rounds',
      paymentsTab: 'Payments',
      position: 'Position',
      joined: 'Joined',
      notStarted: "Tanda hasn't started yet. Rounds will appear once the tanda starts.",
      round: 'Round',
      due: 'Due:',
      completed: 'Completed',
      pending: 'Pending',
      paymentHistory: 'Payment History',
      noPayments: 'No payments recorded yet.',
      paidOn: 'Paid on',
      notPaidYet: 'Not paid yet',
      tandaStatus: 'Tanda Status',
      progress: 'Progress',
      membersJoined: 'members joined',
      inProgress: 'Tanda in progress',
      tandaCompleted: 'Tanda completed',
      tandaCancelled: 'Tanda cancelled',
      nextSteps: 'Next Steps',
      inviteMembers: 'Invite members',
      spotsRemaining: 'spots remaining',
      startTandaStep: 'Start tanda',
      allSpotsFilled: 'All spots are filled',
      makePaymentsStep: 'Make payments',
      dueAccordingSchedule: 'Due according to schedule',
      trackRounds: 'Track rounds',
      monitorFunds: 'Monitor who receives funds',
      tandaRules: 'Tanda Rules',
      ruleContribute: 'Each member contributes',
      ruleReceive: 'One member receives',
      eachRound: 'each round',
      ruleOrder: 'Order is determined randomly when tanda starts',
      ruleOnTime: 'Payments must be made on time',
      ruleLate: 'Late payments may incur penalties',
      ruleOrganizer: 'Organizer manages the tanda and distributions',
      ruleCommission: 'Commission per round:',
      shareTitle: 'Share This Tanda',
      shareText: 'Invite trusted friends and family to join this tanda.',
      copyLink: 'Copy Invite Link',
      linkCopied: 'Link copied!',
      startDialogTitle: 'Start Tanda',
      startDialogWarning: 'Once you start the tanda, you cannot:',
      startDialogWarning1: 'Change member positions',
      startDialogWarning2: 'Add or remove members',
      startDialogWarning3: 'Modify contribution amounts',
      startDialogText: 'The tanda will begin on',
      startDialogText2: 'Member positions will be randomly assigned (except you as organizer will be first).',
      startDialogConfirm: 'Are you sure you want to start this tanda?',
      cancel: 'Cancel',
      deleteDialogTitle: 'Delete Tanda',
      deleteDialogWarning: 'This action cannot be undone. All tanda data will be permanently deleted.',
      deleteDialogText: 'This will delete',
      deleteDialogText2: 'and all associated data including member records and payment history.',
      deleteDialogConfirm: 'Are you sure you want to delete this tanda?',
    },

    // Profile
    profile: {
      title: 'My Profile',
      subtitle: 'Manage your account and view your tanda activity',
      editProfile: 'Edit Profile',
      changePassword: 'Change Password',
      memberSince: 'Member since',
      accountStats: 'Account Stats',
      tandas: 'Tandas',
      paymentsMade: 'Payments Made',
      pendingPayments: 'Pending',
      completedTandas: 'Completed',
      profileTab: 'Profile',
      myTandasTab: 'My Tandas',
      paymentHistoryTab: 'Payment History',
      activityTab: 'Activity',
      profileInfo: 'Your profile information is used to identify you in tanda groups and for communication purposes.',
      fullName: 'Full Name',
      username: 'Username',
      email: 'Email',
      phone: 'Phone Number',
      address: 'Address',
      notProvided: 'Not provided',
      saveChanges: 'Save Changes',
      cancelEdit: 'Cancel',
      myTandas: 'My Tandas',
      noTandas: "You haven't joined or created any tandas yet.",
      paymentHistory: 'Payment History',
      noPayments: 'No payment history available.',
      amount: 'Amount',
      recentActivity: 'Recent Activity',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmNewPassword: 'Confirm New Password',
      changing: 'Changing...',
      change: 'Change Password',
      plan: 'Plan',
    },

    // Plans page
    plans: {
      title: 'Plans & Pricing',
      subtitle: 'Choose the plan that best fits your needs',
      currentPlan: 'Current Plan',
      popular: 'Popular',
      perMonth: '/month',
      free: 'Free',
      selectPlan: 'Select Plan',
      currentLabel: 'Your Current Plan',
      features: 'Features',
      commission: 'commission per round',
      activeTandas: 'active tandas',
      membersPerTanda: 'members per tanda',
      unlimited: 'Unlimited',
      faq: 'FAQ',
      faq1q: 'How is the commission charged?',
      faq1a: 'The commission is automatically deducted from the pot when each round is completed. It is transparent and without surprises.',
      faq2q: 'Can I change plans at any time?',
      faq2a: 'Yes, you can upgrade or downgrade your plan at any time. Changes take effect immediately.',
      faq3q: 'What happens if I cancel my Premium plan?',
      faq3a: 'You return to the Free plan. Your active tandas continue to work, but the Free plan commission will apply to future rounds.',
    },

    // Common
    common: {
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      back: 'Back',
      next: 'Next',
      mxn: 'MXN',
      weekly: 'Weekly',
      biweekly: 'Bi-weekly',
      monthly: 'Monthly',
    },
  },
} as const;

export type Language = keyof typeof translations;
export type TranslationKeys = typeof translations.es;
